import React, { useContext, useEffect, useState } from 'react';
import Heart from "../../../../Assets/Images/HEART.png";
import Soul from "../../../../Assets/Images/SOUL.png";
import Mind from "../../../../Assets/Images/MIND.png";
import Strength from "../../../../Assets/Images/STRENGTH.png";
import HeaderPreview from '../../../GeneratePdf/HeaderPreview';
import FooterPreview from '../../../GeneratePdf/FooterPreview';
import GroupReportContext from '../../../../Context/GroupReportContext';
import { useGroupReportDate } from '../../../../Context/GroupReportDate';
import { logItemsOverviewData } from '../../../../utils/itemsOverviewLogger';

const Logo = (quadrant) => {
  switch (quadrant) {
    case 'HEART':
      return <img src={Heart} alt="Heart" className="logo" />;
    case 'SOUL':
      return <img src={Soul} alt="Soul" className="logo" />;
    case 'MIND':
      return <img src={Mind} alt="Mind" className="logo" />;
    case 'STRENGTH':
      return <img src={Strength} alt="Strength" className="logo" />;
    default:
      return null;
  }
};

const truncateText = (text, limit) => {
  if (text.length <= limit) return text;
  return text.substring(0, text.lastIndexOf(" ", limit)) + "...";
};

const sideLabels = [
  {
    "label": "FULFILLMENT",
    "bg": "#394554"
  },
  {
    "label": "DRIVERS",
    "bg": "#666666"
  },
  {
    "label": "GO-TO'S",
    "bg": "#394554"
  },
  {
    "label": "GUIDING PRINCIPLES",
    "bg": "#666666"
  },
  {
    "label": "MEANING",
    "bg": "#394554"
  },
  {
    "label": "PATTERNS",
    "bg": "#666666"
  },
  {
    "label": "ORIENTATION",
    "bg": "#394554"
  },
  {
    "label": "REWARDS",
    "bg": "#666666"
  }
]

const QF_ItemTwoPage360 = ({ apiData, pageNumber }) => {
  const respondentName = apiData?.fullName?.split(' ')[0] || '[First Name]';
  const { updateTablevaluesq2Page2 } = useGroupReportDate();
  const initialData = [
    { quadrant: 'STRENGTH', no: 3, question: '[First Name] feels most fulfilled when personal tasks are completed.', score: 4 },
    { quadrant: 'HEART', no: 3, question: '[First Name] feels most fulfilled when surrounded by their people.', score: 1 },
    { quadrant: 'SOUL', no: 3, question: '[First Name] is most fulfilled when living out a greater purpose.', score: 2 },
    { quadrant: 'MIND', no: 3, question: '[First Name] is most fulfilled when a project works like it was planned.', score: 3 },
    { quadrant: 'MIND', no: 4, question: '[First Name] is motivated when everything has been thoughtfully planned out.', score: 3 },
    { quadrant: 'STRENGTH', no: 4, question: '[First Name] is motivated by winning.', score: 4 },
    { quadrant: 'HEART', no: 4, question: '[First Name] is motivated when they feel a sense of belonging.', score: 1 },
    { quadrant: 'SOUL', no: 4, question: '[First Name] is motivated by opportunities that develop depth of character.', score: 2 },
    { quadrant: 'STRENGTH', no: 5, question: "[First Name] relies heavily on their drive to complete a project.", score: 4 },
    { quadrant: 'SOUL', no: 5, question: '[First Name] relies heavily on the meaning of their story when working on a project.', score: 2 },
    { quadrant: 'MIND', no: 5, question: '[First Name] needs clear responsibilities to function well in their work.', score: 3 },
    { quadrant: 'HEART', no: 5, question: '[First Name] relies heavily on passion when working on a project.', score: 1 }
  ];
  const [dynamicData, setDynamicData] = useState([...initialData]);
  const groupReportCtx = useContext(GroupReportContext)

  useEffect(() => {
    if (!apiData) {
      setDynamicData(initialData);
      return;
    }

    // 1. Extract Self Data from apiData.bottomQuestions
    const selfScoresMap = new Map();
    if (apiData.bottomQuestions && Array.isArray(apiData.bottomQuestions) && apiData.bottomQuestions.length > 0) {
      apiData.bottomQuestions.forEach(item => {
        const match = item.variable?.match(/^st(\d+)_self_pass([12])$/);
        if (!match) return;

        const rawNo = parseInt(match[1]);
        const passType = match[2];

        let actualScore;
        let actualQuestionNo;

        if (rawNo >= 1 && rawNo <= 10) {
          actualScore = passType === "1" ? 4 : 1;
          actualQuestionNo = rawNo;
        } else if (rawNo >= 11 && rawNo <= 20) {
          actualScore = passType === "1" ? 3 : 2;
          actualQuestionNo = rawNo - 10;
        } else {
          return;
        }

        const key = `${actualQuestionNo}_${actualScore}`;
        selfScoresMap.set(key, actualScore);
      });
    }

    // 2. Group Observers by Designation
    const observersByDesignation = {
      Manager: [],
      DirectReport: [],
      Peer: [],
      Other: []
    };

    if (apiData.memberResults && apiData.memberResults.allMembersData) {
      // Handle allMembersData as an object with keys
      const allMembersData = apiData.memberResults.allMembersData;

      // Convert object to array of members
      const membersArray = Object.values(allMembersData);
      membersArray.forEach(member => {
        const designation = member.designation;

        if (designation && designation.includes('Manager')) {
          observersByDesignation.Manager.push(member);
        } else if (designation && designation.includes('Direct Report')) {
          observersByDesignation.DirectReport.push(member);
        } else if (designation && designation.includes('Peer')) {
          observersByDesignation.Peer.push(member);
        } else if (designation && designation.includes('Other')) {
          observersByDesignation.Other.push(member);
        }
      });
    }

    // 3. Extract Observer Scores
    const observerScoresMap = {
      Manager: new Map(),
      DirectReport: new Map(),
      Peer: new Map(),
      Other: new Map()
    };

    Object.keys(observersByDesignation).forEach(designation => {
      observersByDesignation[designation].forEach(member => {
        if (member.bottomQuestions && Array.isArray(member.bottomQuestions) && member.bottomQuestions.length > 0) {
          member.bottomQuestions.forEach(item => {
            const match = item.variable?.match(/^st(\d+)_self_pass([12])$/);
            if (!match) return;

            const rawNo = parseInt(match[1]);
            const passType = match[2];

            let actualScore;
            let actualQuestionNo;

            if (rawNo >= 1 && rawNo <= 10) {
              actualScore = passType === "1" ? 4 : 1;
              actualQuestionNo = rawNo;
            } else if (rawNo >= 11 && rawNo <= 20) {
              actualScore = passType === "1" ? 3 : 2;
              actualQuestionNo = rawNo - 10;
            } else {
              return;
            }

            const key = `${actualQuestionNo}_${actualScore}`;
            observerScoresMap[designation].set(key, actualScore);
          });
        }
      });
    });

    // 4. Calculate Averages and Update Data
    const updatedData = initialData.map(item => {
      const key = `${item.no}_${item.score}`;

      // Get Self Score
      const selfScore = selfScoresMap.get(key);

      // Get Observer Scores
      const managerScore = observerScoresMap.Manager.get(key);
      const directReportScore = observerScoresMap.DirectReport.get(key);
      const peerScore = observerScoresMap.Peer.get(key);
      const otherScore = observerScoresMap.Other.get(key);

      // Calculate Average
      const allScores = [selfScore, managerScore, directReportScore, peerScore, otherScore]
        .filter(score => score !== undefined && score !== null);

      const average = allScores.length > 0
        ? (allScores.reduce((sum, score) => sum + score, 0) / allScores.length).toFixed(1)
        : '-';

      return {
        ...item,
        self: selfScore || '-',
        manager: managerScore || '-',
        directReport: directReportScore || '-',
        peer: peerScore || '-',
        other: otherScore || '-',
        average: average
      };
    });

    setDynamicData(updatedData);
  }, [apiData]);

  const allMembersDataArray = Object.values(apiData?.memberResults?.allMembersData || {});
  const allVariableSets = allMembersDataArray.map(el => el.variables);
  const allAssessmentDesignation = allMembersDataArray.map(el => el?.designation);
  const allAssessmentHash = allMembersDataArray.map(el => el?.hash);
  const allAssessmentFullName = allMembersDataArray.map(el => el?.fullName);

  const displayData = dynamicData;

  const quadrantScores = {
    "HEART": 1,
    "SOUL": 2,
    "MIND": 3,
    "STRENGTH": 4
  }

  const allResults = [];
  displayData?.forEach((el, index) => {
    // console.log(el.quadrant, quadrantScores?.[el.quadrant])
    const res = groupReportCtx?.calculateQuestionScore(quadrantScores?.[el.quadrant], allVariableSets, el.no, "360_overview", allAssessmentDesignation, allAssessmentHash, allAssessmentFullName);
    if (res?.averageScore !== null) {
      allResults.push(res);
    }
  })

  // Collect all scores and save to context (page3)
  useEffect(() => {
    if (allResults.length > 0) {
      const scoresArray = [];

      // Get first 12 items (as shown in the slice)
      const first12Items = dynamicData.slice(0, 12);

      first12Items.forEach((item, index) => {
        const selfScore = groupReportCtx?.getAverageScore("360 Assessment", allResults, index);
        const managerScore = groupReportCtx?.getAverageScore("360 Assessment Manager", allResults, index);
        const directReportScore = groupReportCtx?.getAverageScore("360 Assessment Direct Report", allResults, index);
        const peerScore = groupReportCtx?.getAverageScore("360 Assessment Peer", allResults, index);
        const otherScore = groupReportCtx?.getAverageScore("360 Assessment Other", allResults, index);
        const averageScore = groupReportCtx?.getObserverAverageScore(allResults, index) ?? "-";

        // Create array with scores only: [selfScore, managerScore, directReportScore, peerScore, otherScore, averageScore]
        const itemScores = [selfScore, managerScore, directReportScore, peerScore, otherScore, averageScore];
        scoresArray.push(itemScores);
      });

      // Save to context in page3 format
      updateTablevaluesq2Page2(scoresArray);
      logItemsOverviewData({
        pageName: "Quadrant Flow 2",
        items: first12Items,
        allResults,
        getAverageScore: groupReportCtx.getAverageScore,
      });
    }
  }, [allResults, dynamicData, groupReportCtx]);

  return (
    <div style={{ backgroundColor: "rgb(255, 255, 255)" }}>
      <HeaderPreview />
      <div className="page" style={{ paddingBottom: "0", height: "634px", boxSizing: "border-box", position: "relative" }}>
        {/* <div className="headerBox">
          <h2 className="title">QUADRANT FLOW 360 ITEMS OVERVIEW</h2>
          <p className="subTitle">
            This page presents a ranking of all 40 items distributed across the four quadrants: Heart, Soul, Mind, and Strength. The rankings are based on 360-degree feedback from self and observers, using a response scale that ranges from 1 (Least) to 4 (Most). Any unselected statement will appear as "-" in the Items Overview chart.
          </p>
        </div> */}

        <div className="content">
          <div className="table" style={{ position: "relative" }}>
            <div className="tableRow tableHeader" style={{ background: "#245775", color: "#fff", display: "flex", zIndex: "1", position: "relative" }}>
              <div className="cellIndex" style={{ marginLeft: "40px", display: "flex", alignItems: "center" }}>#</div>
              <div className="cellQuadrant" style={{ fontSize: "9px", padding: "5.5px 0px 5.5px 13px", lineHeight: "13px" }}>Quadrant</div>
              <div className="cellLogo"></div>
              <div className="cellQuestion" style={{ marginLeft: "4px", marginRight: "10px" }}>Question</div>
              <div className="cellscore-parent" style={{ display: "flex", marginLeft: "16px" }}>
                <div className="cellScore">S</div>
                <div className="cellScore">M</div>
                <div className="cellScore">D</div>
                <div className="cellScore">P</div>
                <div className="cellScore">O</div>
                <div className="cellScore">A</div>
              </div>
            </div>

            {dynamicData.slice(0, 12).map((item, index) => {

              const selfScore = Number(groupReportCtx?.getAverageScore("360 Assessment", allResults, index));
              const managerScore = Number(groupReportCtx?.getAverageScore("360 Assessment Manager", allResults, index));
              const directReportScore = Number(groupReportCtx?.getAverageScore("360 Assessment Direct Report", allResults, index));
              const peerScore = Number(groupReportCtx?.getAverageScore("360 Assessment Peer", allResults, index));
              const otherScore = Number(groupReportCtx?.getAverageScore("360 Assessment Other", allResults, index));
              const averageScore = Number(groupReportCtx?.getObserverAverageScore(allResults, index));
              const getLabelByIndex = (index) => {
                if (index === 0) {
                  return sideLabels[0].label
                }

                return sideLabels[index / 4].label
              }

              const getStyleByIndex = (index) => {
                if (index === 0) {
                  return {
                    top: "18px",
                    height: "33%",
                    backgroundColor: `${sideLabels[0].bg}`,
                  }
                }
                else if (index === 4) {
                  return {
                    top: "36%",
                    height: "33%",
                    backgroundColor: `${sideLabels[index / 4].bg}`
                  }
                }

                return {
                  top: "68%",
                  height: "35%",
                  backgroundColor: `${sideLabels[index / 4].bg}`
                }
              }

              return <div key={index} style={{ display: "flex", alignItems: "center", padding: "5px 0", }} className={`tableRow ${index % 2 === 0 ? 'evenRow' : 'oddRow'}`}>
                <div className='cellIndex'></div>
                {
                  index === 0 || index % 4 == 0
                    ? <div className="sidelables" style={getStyleByIndex(index)}>{getLabelByIndex(index)}</div>
                    : <></>
                }
                <div className="cellIndex" style={{ marginLeft: "30px" }}>{index + 9}.</div>
                <div className="cellQuadrant" style={{ width: "50px", marginLeft: "11px" }}>{item.quadrant}</div>
                <div className="cellLogo">{Logo(item.quadrant)}</div>
                <div className="cellQuestion">{item.question.replace(/\[First Name\]/g, respondentName)}</div>
                <div className="cellScore-parent" style={{ display: "flex", alignItems: "center", marginLeft: "25px" }}>
                  <div className="cellScore">{typeof selfScore === 'number' && !Number.isNaN(selfScore) ? Number(selfScore).toFixed(1) : '-'}</div>
                  <div className="cellScore">{typeof managerScore === 'number' && !Number.isNaN(managerScore) ? Number(managerScore).toFixed(1) : '-'}</div>
                  <div className="cellScore">{typeof directReportScore === 'number' && !Number.isNaN(directReportScore) ? Number(directReportScore).toFixed(1) : '-'}</div>
                  <div className="cellScore">{typeof peerScore === 'number' && !Number.isNaN(peerScore) ? Number(peerScore).toFixed(1) : '-'}</div>
                  <div className="cellScore">{typeof otherScore === 'number' && !Number.isNaN(otherScore) ? Number(otherScore).toFixed(1) : '-'}</div>
                  <div className="cellScore">{averageScore === 0 || Number.isNaN(averageScore) ? "-" : averageScore.toFixed(1)}</div>
                </div>
              </div>
            })}
          </div>
        </div>
        <div className='details-footer' style={{ position: "absolute", bottom: "4px", width: "100%", boxSizing: "border-box", margin: "0" }}>
          <ul className='details-list' style={{ padding: "4px" }}>
            <li>S - Self</li>
            <li>M - Manager</li>
            <li>D - Direct Report</li>
            <li>P - Peer</li>
            <li>O - Other</li>
            <li>A - Average</li>
          </ul>
        </div>
      </div>
      <FooterPreview reportType={"360 REPORT"} pageNumber={pageNumber} />
    </div>
  );
};

export default QF_ItemTwoPage360;
